import { ModuleWithProviders, NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'

import { CheckoutRoutingModule } from './checkout-routing.module'
import { CheckoutEffects } from './effects/checkout'
import { reducer } from './reducers'

import { CheckoutService } from './services/checkout-service'
import { DeliveryDateService } from './services/deliverydate-service'
import { BackorderCountsService } from './services/backordercount-service'

import { CheckoutContainer } from './containers/checkout-container'
import { SummaryContainer } from './containers/summary-container'

import { CartTableComponent } from './components/cart-table'
import { CartTableLineComponent } from './components/cart-table-line'
import { AddressComponent } from './components/address'
import { SharedModule } from '../shared/shared.module'
import { AddressesComponent } from './components/addresses'
import { CheckoutPageComponent } from './components/checkout-page'
import { SummaryPageComponent } from './components/summary-page'
import { CheckoutSecondStepContainer } from './containers/checkout-second-step-container';
import { CheckoutSecondStepPageComponent } from './components/checkout-second-step-page';

@NgModule({
  imports: [
    RouterModule,
    SharedModule
  ],
  declarations: [
    CheckoutContainer,
    CheckoutSecondStepContainer,
    SummaryContainer,
    CheckoutPageComponent,
    CheckoutSecondStepPageComponent,
    SummaryPageComponent,
    CartTableComponent,
    CartTableLineComponent,
    AddressComponent,
    AddressesComponent
  ]
})
export class CheckoutModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: RootCheckoutModule,
      providers: [
        CheckoutService,
        DeliveryDateService,
        BackorderCountsService
      ]
    }
  }
 }

@NgModule({
  imports: [
    CheckoutModule,
    CheckoutRoutingModule,
    StoreModule.forFeature('checkout', reducer),
    EffectsModule.forFeature([CheckoutEffects])
  ]
})
export class RootCheckoutModule {}
